import React from 'react';
import { isEmpty } from 'lodash';

import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import ACMedia from './ACMedia';

import styles from './ACUIElement.module.scss';
import ACClue from './ACClue';
import ACChallange from './ACChallange';

export default class ACUIElement extends React.Component {
  onUploadACUIElementMedia = (e) => {
    if (!e.target) return null;
    const { files = [] } = e.target;
    const { name, onUploadACUIElementMediaFunc, uiElement, mediaFor } = this.props;
    const { media = {} } = uiElement;
    const { type = '' } = media;
    onUploadACUIElementMediaFunc(name, mediaFor, type, files[0] || {});
  };

  onClearACUIElementMedia = () => {
    const { uiElement = {}, onChangeACUIElementFunc } = this.props;
    delete uiElement.media;
    delete uiElement.medias;
    onChangeACUIElementFunc(uiElement);
  };

  onChangeText = (e) => {
    if (isEmpty(e) || isEmpty(e.target)) return null;
    const { name = '', value = '' } = e.target;
    const { uiElement, onChangeACUIElementFunc } = this.props;
    uiElement[name] = value;

    onChangeACUIElementFunc(uiElement);
  };

  onChangeClueSolvable = (key, value) => {
    const { uiElement, onChangeACUIElementFunc } = this.props;
    uiElement[key] = value;
    onChangeACUIElementFunc(uiElement);
  };

  onChangeChallangeSolvable = (key, value) => {
    const { uiElement, onChangeACUIElementFunc } = this.props;
    uiElement[key] = value;
    onChangeACUIElementFunc(uiElement);
  };


  onChangeVideoUrl = (e) => {
    if (isEmpty(e) || isEmpty(e.target)) return null;
    const { value = '' } = e.target;
    const { uiElement, onChangeACUIElementFunc } = this.props;
    const { media = {} } = uiElement;

    media.url = value;
    uiElement.media = media;
    onChangeACUIElementFunc(uiElement);
  };

  onChangeMediaType = (name, selectedOption) => {
    const { uiElement = {}, onChangeACUIElementFunc } = this.props;
    const { value = '' } = selectedOption;
    const { media = {} } = uiElement;
    media[name] = value;
    media.url = '';
    uiElement.media = media;
    onChangeACUIElementFunc(uiElement);
  };

  render() {
    const {
      name,
      uiElement = {},
      showHeading = true,
      showSubheading = true,
      showBody = true,
      showMedia = true,
      isMediaTypeDisabled = false,
      showSolvable = false,
      showSolvableChallange=false,
      spark,
      placeholderHead = '',
      placeholderSubhead = '',
      placeholderBody = '',
      showTitle = false,
      titleHeading = '',
      showMediaIntro = false,
    } = this.props;
    let { mediaName = '' } = this.props;
    mediaName = !isEmpty(mediaName) ? mediaName : name;
    const {
      heading = '',
      subHeading = '',
      body = '',
      media = {},
      solvable = false,
      solvableClue = spark?.name,
      solvableChallange=heading,
      title = '',
    } = uiElement;
    return (
      <React.Fragment>
        {showMediaIntro && (
          <ACMedia
            name={mediaName}
            media={media}
            onChangeMediaTypeFunc={this.onChangeMediaType}
            onUploadMediaFunc={this.onUploadACUIElementMedia}
            onChangeVideoUrlFunc={this.onChangeVideoUrl}
            onClearMediaFunc={this.onClearACUIElementMedia}
            isMediaTypeDisabled={isMediaTypeDisabled}
          />
        )}
        {showTitle && (
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" className={styles.adornment}>
                  {titleHeading}
                </InputAdornment>
              ),
            }}
            className={styles.textField}
            name="title"
            value={title || solvableClue || ''}
            onChange={this.onChangeText}
            placeholder={placeholderHead}
          />
        )}
        {showHeading && (
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" className={styles.adornment}>
                  Heading
                </InputAdornment>
              ),
            }}
            className={styles.textField}
            name="heading"
            value={heading}
            onChange={this.onChangeText}
            placeholder={placeholderHead}
          />
        )}
        {showSubheading && (
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" className={styles.adornment}>
                  Sub Heading
                </InputAdornment>
              ),
            }}
            className={styles.textField}
            name="subHeading"
            value={subHeading}
            onChange={this.onChangeText}
            placeholder={placeholderSubhead}
          />
        )}
        {showBody && (
          <TextField
            InputProps={{
              startAdornment: (
                <InputAdornment position="start" className={styles.adornment}>
                  Body
                </InputAdornment>
              ),
            }}
            className={styles.textField}
            name="body"
            value={body}
            onChange={this.onChangeText}
            multiline
            rows="8"
            placeholder={placeholderBody}
          />
        )}
        {showMedia && (
          <ACMedia
            name={mediaName}
            media={media}
            onChangeMediaTypeFunc={this.onChangeMediaType}
            onUploadMediaFunc={this.onUploadACUIElementMedia}
            onChangeVideoUrlFunc={this.onChangeVideoUrl}
            onClearMediaFunc={this.onClearACUIElementMedia}
            isMediaTypeDisabled={isMediaTypeDisabled}
          />
        )}
        {showSolvable && (
          <ACClue
            style={{
              paddingLeft: 10,
            }}
            isChecked={solvable}
            onCheckChanged={(e) => {
              this.onChangeClueSolvable('solvable', !!e.target.checked);
              if (e.target.checked) {
                setTimeout(() => {
                  this.onChangeClueSolvable(
                    'solvableClue',
                    !!solvableClue ? solvableClue : spark?.name
                  );
                }, 700);
              }
            }}
            clueValue={solvableClue}
            onClueValueChanged={(e) => {
              this.onChangeClueSolvable('solvableClue', e.target.value);
            }}
          />
        )}
        {showSolvableChallange && (
          <ACChallange
            style={{
              paddingLeft: 10,
            }}
            isChecked={solvable}
            onCheckChanged={(e) => {
              this.onChangeChallangeSolvable('solvable', !!e.target.checked);
              if (e.target.checked) {
                setTimeout(() => {
                  this.onChangeChallangeSolvable(
                    'solvableChallange',
                    !!solvableChallange ? solvableChallange : spark?.name
                  );
                }, 700);
              }
            }}
            challangeValue={solvableChallange}
            onChallangeValueChanged={(e) => {
              this.onChangeChallangeSolvable('solvableChallange', e.target.value);
            }}
            soutions={this.props.solutions}
          />
        )}
      </React.Fragment>
    );
  }
}
